"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _usePrefix = require("../../internal/usePrefix");

var _excluded = ["className"];

var SwitcherDivider = function SwitcherDivider(_ref) {
  var customClassName = _ref.className,
      other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = (0, _usePrefix.usePrefix)();
  var className = (0, _classnames.default)("".concat(prefix, "--switcher__item--divider"), (0, _defineProperty2.default)({}, customClassName, !!customClassName));
  return /*#__PURE__*/_react.default.createElement("hr", (0, _extends2.default)({}, other, {
    className: className
  }));
};

SwitcherDivider.propTypes = {
  /**
   * Optionally provide a custom class to apply to the underlying `<li>` node
   */
  className: _propTypes.default.string
};
var _default = SwitcherDivider;
exports.default = _default;